import { render, staticRenderFns } from "./sendSmsContract.vue?vue&type=template&id=60cc9e40&scoped=true"
import script from "./sendSmsContract.vue?vue&type=script&lang=js"
export * from "./sendSmsContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc9e40",
  null
  
)

export default component.exports